import { BANK_PROCESSING_NOTICE } from "../services/identity/nuban";
import React, { useEffect, useState } from "react";
import { Alert, Box, Card, CircularProgress, Typography } from "@mui/material";

import { API } from "../constant/apiConstant";
import { Colors } from "../utils/colors";

export default function LegalDocument({ documentType }) {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const res = await fetch(`${API.BASE_URL}/api/settings`);
        const data = await res.json();

        if (data?.status && data.settings) {
          setContent(
            documentType === "privacy"
              ? data.settings.privacy_policy || ""
              : documentType === "cookies"
              ? data.settings.cookie_policy || ""
              : data.settings.terms_conditions || ""
          );
        }
      } catch (error) {
        console.log(error);
      }

      setLoading(false);
    };

    loadSettings();
  }, [documentType]);

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Card
        sx={{
          width: "100%",
          maxWidth: 900,
          p: { xs: 3, md: 5 },
          borderRadius: 2,
          background: "#fff"
        }}
      >
        <Typography variant="h4" fontWeight={700} sx={{ color: Colors.secondary, mb: 1 }}>
          {documentType === "privacy"
            ? "Privacy Policy"
            : documentType === "cookies"
            ? "Cookies Policy"
            : "Terms and Conditions"}
        </Typography>
        <Typography sx={{ color: Colors.muted, mb: 3 }}>
          Please read this document carefully before continuing to use FlipLottery.
        </Typography>

        {documentType !== "cookies" && <Alert severity="info" sx={{ mb: 2 }}>{BANK_PROCESSING_NOTICE}</Alert>}
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
            <CircularProgress />
          </Box>
        ) : content ? (
          <Typography sx={{ whiteSpace: "pre-wrap", lineHeight: 1.9, color: Colors.text }}>
            {content}
          </Typography>
        ) : (
          <Alert severity="info">No legal content has been published yet.</Alert>
        )}
      </Card>
    </Box>
  );
}
